import { VEHICLE_WEIGHT_CLASSES } from "@/shared/constants/offer-cargo";
import {
  VEHICLE_EQIUIPMENTS,
  VEHICLE_SHAPES_LIST,
} from "@/shared/constants/vehicle";
import { excludeNull } from "@/shared/lib/collection";
import { BaseKeyValue } from "@/shared/ui/BaseKeyValue";
import { BaseHeaderWrapper } from "@/shared/ui/base-header-wrapper";
import { NullableValueText } from "@/widgets/value-with-label";
import type { MasterDataVehicleCreatePageProps } from "../../model";

export const MasterDataVehicleInfo = ({
  offices,
  previewValues,
}: {
  offices: NonNullable<MasterDataVehicleCreatePageProps["offices"]>;
  previewValues: NonNullable<MasterDataVehicleCreatePageProps["previewValues"]>;
}) => {
  const selectedOffice = offices.data?.find(
    (office) => office.id === previewValues.officeId,
  );
  const selectedVehicleWeightClass = VEHICLE_WEIGHT_CLASSES.find(
    (vehicleWeightClass) =>
      vehicleWeightClass.value === previewValues.weightClass,
  );
  const selectedShape = VEHICLE_SHAPES_LIST.find(
    (shape) => shape.value === previewValues.shape,
  );
  const selectedEquipments = excludeNull(
    previewValues.vehicleEquipments?.map((equipment) => {
      return VEHICLE_EQIUIPMENTS.find(
        (vehicleEquipment) => vehicleEquipment.value === equipment,
      );
    }) ?? [],
  );
  return (
    <BaseHeaderWrapper title="車両" maxWidth="628px">
      <BaseKeyValue keyLabel="車両ナンバー">
        <NullableValueText value={previewValues.number} />
      </BaseKeyValue>
      <BaseKeyValue keyLabel="事業所">
        <NullableValueText value={selectedOffice?.name} />
      </BaseKeyValue>
      <BaseKeyValue keyLabel="車名">
        <NullableValueText value={previewValues.name} />
      </BaseKeyValue>
      <BaseKeyValue keyLabel="トン数(車格)">
        <NullableValueText value={selectedVehicleWeightClass?.label} />
      </BaseKeyValue>
      <BaseKeyValue keyLabel="ボディタイプ(形状)">
        <NullableValueText value={selectedShape?.label} />
      </BaseKeyValue>
      <BaseKeyValue keyLabel="装備品">
        <NullableValueText
          value={selectedEquipments.map((e) => e.label).join(" / ")}
        />
      </BaseKeyValue>
      <BaseKeyValue keyLabel="その他・特記事項">
        <NullableValueText value={previewValues.memo} />
      </BaseKeyValue>
    </BaseHeaderWrapper>
  );
};
